export const CHANGE_THEME = "CHANGE_THEME"
export const CHANGE_USER_SETTINGS = "CHANGE_USER_SETTINGS"